"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Stopwatch = /** @class */ (function () {
    function Stopwatch() {
        this.start = performance.now();
        this._last = this.start;
    }
    Stopwatch.prototype.msraw = function () {
        this._last = performance.now();
        return (this._last - this.start) / 1000;
    };
    Stopwatch.prototype.lapraw = function () {
        var last = this._last;
        this._last = performance.now();
        return (this._last - last) / 1000;
    };
    Stopwatch.prototype.ms = function () {
        this._last = performance.now();
        return "".concat(this.msraw().toFixed(3), "s");
    };
    Stopwatch.prototype.lap = function () {
        return "".concat(this.lapraw().toFixed(3), "s");
    };
    Stopwatch.prototype.parse = function (s) {
        if (!s)
            return 0;
        return Number(s.slice(0, -1));
    };
    return Stopwatch;
}());
exports.default = Stopwatch;
//# sourceMappingURL=stopwatch.js.map